import { useMemo } from 'react';
import { useGetCatalogResourcesQuery } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/v1/CatalogResourceChirpFrontendService.hooks';
import { CatalogShortFormContentResponseTypename } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/v1/CatalogResourceChirpFrontendService';
export const useFullShort = (shortId, skip) => {
  const {
    data,
    loading: shortLoading,
    error: shortError
  } = useGetCatalogResourcesQuery({
    skip,
    variables: {
      requestedResources: [{
        resourceId: shortId,
        type: 'SHORT_FORM_CONTENT'
      }]
    }
  });
  const short = useMemo(() => {
    var _data$results;
    if (!(data !== null && data !== void 0 && (_data$results = data.results) !== null && _data$results !== void 0 && _data$results.length)) {
      return undefined;
    }
    const result = data.results[0];
    if (result.__typename === CatalogShortFormContentResponseTypename) {
      return result;
    }
    return undefined;
  }, [data]);
  return {
    short,
    shortLoading,
    shortError
  };
};